// While the login is shown over an open page (the session ended), nothing of the page's content
// may stay on screen or in the document: the next person at the device could read it. A page that
// records is kept mounted all the same – the recording must not stop – and so is a page with text
// typed into it; such a page renders only what useContentHidden() allows (RecordingKeptCard).
import { createContext, useContext, type ReactNode } from 'react';
import { formatDuration } from '../lib/format';

const ContentHiddenContext = createContext(false);

export function ContentHidden({ hidden, children }: { hidden: boolean; children: ReactNode }) {
  return <ContentHiddenContext.Provider value={hidden}>{children}</ContentHiddenContext.Provider>;
}

/** True while the page must not show its content (it stays mounted for a recording or a draft). */
export function useContentHidden(): boolean {
  return useContext(ContentHiddenContext);
}

/** All a hidden page shows: that a recording runs and for how long – no title, no text. */
export function RecordingKeptCard({ recording, elapsedMs }: { recording: boolean; elapsedMs: number }) {
  if (!recording) return null;
  return (
    <div className="page page--center">
      <section className="card empty-card" aria-label="Snemanje">
        <p className="rec-status">
          <span className="rec-dot" aria-hidden="true" />
          Snemanje se nadaljuje
        </p>
        <div className="timer" role="timer" aria-label="Trajanje posnetka">
          {formatDuration(elapsedMs)}
        </div>
        <p className="muted">Posnetek se sproti shranjuje v tej napravi. Ko se znova prijavite, ga lahko končate in bo poslan na strežnik.</p>
      </section>
    </div>
  );
}
